import type { RouteRecordRaw } from 'vue-router'
import { authRoutes } from '@/my/modules/auth/auth.routes'
import { accountRoutes } from '@/my/modules/account/account.routes'

export const myRoutes: RouteRecordRaw[] = [
  ...authRoutes,
  ...accountRoutes,
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404'
  }
]
